module.exports = __webpack_public_path__ + "img/reason15.73c06109.png";